<template lang="html">
  <div id="text-page">
    <section class="header-banners-section-s2">
    </section>

    <section class="container main-section" data-aos="fade-in" data-aos-duration="1000">
      <h1 class="mb-2 text-center page-title">Aviso de privacidad</h1>

      <p>
        Protección de sus datos personales
      </p>
      <p>
        En Marquez Express Inc., con domicilio en 503 Interamerica Blvd, Laredo, TX 78045, USA, valoramos y respetamos la privacidad de la información que usted nos proporciona. Este aviso tiene como fin informarle cómo tratamos sus datos personales y documentos enviados a través de nuestro sitio web.
      </p>

      <br />
      <h6>1. ¿Qué información recopilamos?</h6>
      <p>
        A través del formulario de registro en nuestro sitio web, podemos solicitar y almacenar la siguiente información:
      </p>
      <ul>
        <li>Nombre completo</li>
        <li>Número telefónico y correo electrónico</li>
        <li>Licencia federal</li>
        <li>Pasaporte</li>
        <li>Visa vigente (B1 o similar)</li>
        <li>CURP</li>
        <li>Fotografía personal</li>
      </ul>

      <br />
      <h6>2. ¿Para qué utilizamos sus datos?</h6>
      <p>
        La información se utiliza exclusivamente para:
      </p>
      <ul>
        <li>Evaluar perfiles de operadores y dueños de camión interesados en colaborar con nosotros</li>
        <li>Establecer contacto en caso de existir una oportunidad compatible</li>
        <li>Gestionar un expediente digital interno para fines operativos y de validación</li>
      </ul>

      <br />
      <h6>3. ¿Compartimos su información?</h6>
      <p>
        No compartimos, vendemos ni transferimos su información a terceros ajenos a Marquez Express Inc.
      </p>
      <p>
        Todos los datos se manejan de manera interna y bajo medidas razonables de resguardo.
      </p>

      <br />
      <h6>4. Consentimiento</h6>
      <p>
        Al enviar su información a través de nuestro sitio web, usted autoriza voluntariamente el uso de sus datos conforme a lo señalado en este aviso.<br />
        Nos comprometemos a utilizar su información exclusivamente para los fines indicados, y a mantenerla segura y confidencial.
      </p>
    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      content: '',
    }
  },

  methods: {
    getContent: function(){
      axios.get(tools.url('/privacidad')).then((response)=>{
        this.content = response.data;;
      }).catch((error)=>{
        console.log(error);
      })
    }
  },

  beforeMount(){
    // this.getContent();
  }
}
</script>
